import { render, staticRenderFns } from "./tradingFlow.vue?vue&type=template&id=20dc5942&scoped=true&"
import script from "./tradingFlow.vue?vue&type=script&lang=js&"
export * from "./tradingFlow.vue?vue&type=script&lang=js&"
import style0 from "./tradingFlow.vue?vue&type=style&index=0&id=20dc5942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc5942",
  null
  
)

export default component.exports